import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRightIcon } from 'lucide-react';
import { closingLines } from '../data/offer';
export function ClosingSection() {
  return <section className="bg-background py-16 sm:py-20" aria-labelledby="closing-title" data-id="element-40" data-mp="12su1nsplz4ev">
      <div className="mx-auto max-w-4xl px-4" data-id="element-41" data-mp="12qhb4r5sblq7">
        <h2 id="closing-title" className="text-balance text-center font-display text-4xl font-extrabold uppercase leading-[1.02] tracking-tight text-foreground sm:text-5xl" data-id="element-42" data-mp="xspgvqho3niu">
          Stop Struggling. <span className="text-electric" data-id="element-43" data-mp="17sq4homkkpsu">Start Understanding.</span>
        </h2>

        <ul className="mx-auto mt-10 grid max-w-3xl gap-3" data-id="element-44" data-mp="1ljuxi7vfmju7">
          {closingLines.map((line, index) => <motion.li key={line} initial={{
          opacity: 0,
          x: -10
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.28,
          delay: index * 0.04,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex items-center gap-3 rounded-xl border border-electric/20 border-l-4 border-l-electric bg-surface px-4 py-3.5 text-sm font-semibold text-foreground sm:text-base" data-id="element-45" data-mp="1hhzzpdcpmol6" data-mpi={index}>
              <ChevronRightIcon className="h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-46" data-mp="2carygs85cabk" />
              {line}
            </motion.li>)}
        </ul>
      </div>
    </section>;
}